import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  skip: 0,
  limit: 5,
};

const purchaseHistorySlice = createSlice({
  name: "purchaseHistory",
  initialState,
  reducers: {
    setSkip: (state, action) => {
      state.skip = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
  },
});

export const { setSkip, setLimit } = purchaseHistorySlice.actions;
export default purchaseHistorySlice.reducer;
